import { throwErrorMessage } from 'dashboard/store/utils/api';
import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import * as types from '../mutation-types';
import CustomMenuAPI from '../../api/customMenu';

export const state = {
  records: [],
  uiFlags: {
    fetchingList: false,
    creatingItem: false,
    updatingItem: false,
    deletingItem: false,
  },
};

export const getters = {
  getCustomMenus($state) {
    return $state.records;
  },
  getEnabledCustomMenus($state) {
    return $state.records.filter(menu => menu.enabled);
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getCustomMenuById: $state => id => {
    return $state.records.find(menu => menu.id === Number(id));
  },
};

export const actions = {
  getCustomMenus: async function getCustomMenus({ commit }) {
    commit(types.default.SET_CUSTOM_MENU_UI_FLAG, { fetchingList: true });
    try {
      const response = await CustomMenuAPI.get();
      commit(types.default.SET_CUSTOM_MENU, response.data);
      commit(types.default.SET_CUSTOM_MENU_UI_FLAG, { fetchingList: false });
    } catch (error) {
      commit(types.default.SET_CUSTOM_MENU_UI_FLAG, { fetchingList: false });
    }
  },

  createCustomMenu: async function createCustomMenu({ commit }, customMenuObj) {
    commit(types.default.SET_CUSTOM_MENU_UI_FLAG, { creatingItem: true });
    try {
      const response = await CustomMenuAPI.create(customMenuObj);
      commit(types.default.ADD_CUSTOM_MENU, response.data);
      commit(types.default.SET_CUSTOM_MENU_UI_FLAG, { creatingItem: false });
      return response.data;
    } catch (error) {
      commit(types.default.SET_CUSTOM_MENU_UI_FLAG, { creatingItem: false });
      return throwErrorMessage(error);
    }
  },

  updateCustomMenu: async function updateCustomMenu(
    { commit },
    { id, ...updateObj }
  ) {
    commit(types.default.SET_CUSTOM_MENU_UI_FLAG, { updatingItem: true });
    try {
      const response = await CustomMenuAPI.update(id, updateObj);
      commit(types.default.EDIT_CUSTOM_MENU, response.data);
      commit(types.default.SET_CUSTOM_MENU_UI_FLAG, { updatingItem: false });
      return response.data;
    } catch (error) {
      commit(types.default.SET_CUSTOM_MENU_UI_FLAG, { updatingItem: false });
      return throwErrorMessage(error);
    }
  },

  deleteCustomMenu: async function deleteCustomMenu({ commit }, id) {
    commit(types.default.SET_CUSTOM_MENU_UI_FLAG, { deletingItem: true });
    try {
      await CustomMenuAPI.delete(id);
      commit(types.default.DELETE_CUSTOM_MENU, id);
      commit(types.default.SET_CUSTOM_MENU_UI_FLAG, { deletingItem: false });
      return id;
    } catch (error) {
      commit(types.default.SET_CUSTOM_MENU_UI_FLAG, { deletingItem: false });
      return throwErrorMessage(error);
    }
  },
};

export const mutations = {
  [types.default.SET_CUSTOM_MENU_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.default.SET_CUSTOM_MENU]: MutationHelpers.set,
  [types.default.ADD_CUSTOM_MENU]: MutationHelpers.create,
  [types.default.EDIT_CUSTOM_MENU]: MutationHelpers.update,
  [types.default.DELETE_CUSTOM_MENU]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
